<template>
	<div class="modal fade" role="dialog" aria-labelledby="closeTareasOportunidadLabel" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="closeTareasOportunidadLabel">
						Tareas asociadas al cliente
					</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body p-0">
					<preloader v-if="loading"></preloader>
					<div>
						<div v-if="tareas.length>0" class="m-3">
							<button class="btn btn-primary mb-3" v-on:click="getTareas" v-tooltip="'Actualizar'">
								<i class="material-icons">refresh</i>
							</button>
	                        
	                        <div class="list-group">
						    	<div class="flex-column align-items-start list-group-item list-group-item-action" v-for="(tarea, index) in tareas">
									<div class="d-flex w-100 justify-content-between">
								  		<div v-bind:class="{'mb-1':true, 'text-black-38':tarea.ESTATUS=='C'}">
									  		<h5 class="m-0">
									  			<small v-bind:class="{'badge':true, 'badge-info':tarea.ESTATUS=='A', 'badge-danger':tarea.ESTATUS=='C'}">
							  						{{formatDate(tarea.FECHA)}}	
							  					</small> | {{tarea.TIPO_TAREA}}
									  		</h5>
								  			<p v-bind:class="{'mb-0':true, 'text-black-38':tarea.ESTATUS=='C', 'text-muted':tarea.ESTATUS!='C'}">
												{{tarea.NOTAS}}
											</p>
								  		</div>
									</div>
								</div>
							</div>
						</div>
						<empty icon="event" title="Agregar Tareas" description="Para poder visualizar el listado de las Tareas debes agregar una nueva." v-if="tareas.length<=0 && !loading">
						</empty>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				cliente: 0,
				loading: false,
				tareas:[],
			}
		},

		mounted(){
			this.loading = true;
			var vm = this;
			$(this.$el).on('shown.bs.modal', function (event) {
				var button = $(event.relatedTarget);
				var cliente = button.data('cliente');
				vm.cliente = cliente;
				vm.getTareas();
			});
		},

		methods: {
			getTareas: function(){
				this.loading = true;
				var url = 'api/clientes/'+this.cliente+'/tareas';

				axios.get(url)
				.then(response => {
					this.tareas = response.data;
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			formatDate: function(date){
				return moment(date).format("DD-MM-YYYY HH:mm");
			}
		},
	}
</script>